export default __webpack_public_path__ + "static/B2BIntegratorCloud-97961841961edeb5f83a293227dedaac.png";